import { defineMessages } from 'react-intl';

export default defineMessages({
    searchStorageFacility: {
        id: 'quoteandbind.PPRLinedirectives.templates.PropertyDetails.searchStorageFacility',
        defaultMessage: 'Search Storage Facility'
    },
    clearStorageFacility: {
        id: 'quoteandbind.PPRLinedirectives.templates.PropertyDetails.clearStorageFacility',
        defaultMessage: 'Clear the selected Storage Facility'
    },
    emptyResultWarningMessage: {
        id: 'quoteandbind.PPRLinedirectives.templates.PropertyDetails.Please enter Other into Approved Storage Facilities if facility was not found',
        defaultMessage: 'Please enter \'Other\' into \'Approved Storage Facilities\' if facility was not found.'
    }
});